import { Switch } from "@mui/material";
import { SettingCard } from "./settings-card";
import type { SwitchProps } from "@mui/material/Switch";

type BooleanSwitchProps = {
  title: string;
  value: boolean;
  onChange: SwitchProps["onChange"];
};

export const BooleanSwitch = ({
  title,
  value,
  onChange,
}: BooleanSwitchProps) => {
  return (
    <SettingCard title={title}>
      <Switch checked={value} onChange={onChange} color="primary" />
    </SettingCard>
  );
};
